"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("../styles/AddressInput.scss");
var AddressSummary_1 = require("./AddressSummary");
var AddressFinder_1 = require("./AddressFinder");
var AddressManualInput_1 = require("./AddressManualInput");
// We need to escape element IDs that contain a dot since the querySelector
// will interpret the dot as if we're looking for a class
var getEscapedQuerySelector = function (querySelector) { return querySelector.replace(/\./g, '\\.'); };
var AddressInput = /** @class */ (function (_super) {
    __extends(AddressInput, _super);
    function AddressInput(props) {
        var _this = _super.call(this, props) || this;
        _this.addressSummary = function () { return React.createElement(AddressSummary_1.default, { address: _this.props.address, handleEnterManually: _this.handleEnterManually, clearAddress: _this.clearAddress, removeAddressIcon: _this.props.removeAddressImg, label: _this.props.label, errors: _this.props.errors }); };
        _this.addressFinder = function () { return React.createElement(AddressFinder_1.default, { api: _this.props.api, name: _this.props.name, label: _this.props.label, disabled: _this.props.disabled, address: _this.props.address, validateAll: _this.validateAll, setStage: _this.setStage, errors: _this.props.errors, handleEnterManually: _this.handleEnterManually, handleChange: _this.props.handleChange, track: _this.props.track }); };
        _this.addressManualInput = function () { return React.createElement(AddressManualInput_1.default, { name: _this.props.name, errors: _this.props.errors, address: _this.props.address, handleChange: _this.props.handleChange, validateField: _this.props.validateField, clearAddress: _this.clearAddress, handleDone: _this.handleDone }); };
        _this.setStage = function (newStage) {
            _this.setState({ stage: newStage });
        };
        _this.handleEnterManually = function (event) {
            if (event) {
                event.preventDefault();
            }
            _this.setState({
                stage: 'manual',
            });
            _this.props.removeErrors(_this.getFieldSet());
        };
        _this.validateAll = function (update) {
            return _this.props.validateList(_this.getFieldSet(), update);
        };
        _this.getFieldSet = function () {
            return [
                _this.props.name + ".flat",
                _this.props.name + ".house_number",
                _this.props.name + ".house_name",
                _this.props.name + ".street",
                _this.props.name + ".district",
                _this.props.name + ".county",
                _this.props.name + ".town",
                _this.props.name + ".postcode"
            ];
        };
        _this.hasPopulatedData = function () {
            return Object.keys(_this.props.address).reduce(function (current, field) {
                return (_this.props.address[field] !== undefined) || current;
            }, false);
        };
        _this.handleDone = function () {
            if (!_this.validateAll(true)) {
                return;
            }
            if (typeof _this.props.track !== 'undefined') {
                var interactionsEvent = {
                    target: {
                        eventName: 'Address',
                        action: _this.props.name,
                        label: 'Entered manually'
                    }
                };
                _this.props.track(interactionsEvent);
            }
            _this.setState({
                stage: 'selected',
            });
            _this.focusElement('button.summary');
        };
        _this.clearAddress = function (event) {
            event.preventDefault();
            _this.setState({
                stage: 'finder',
            });
            _this.props.handleChange({
                target: {
                    name: _this.props.name,
                    value: {
                        county: undefined,
                        flat: undefined,
                        house_name: undefined,
                        house_number: undefined,
                        postcode: undefined,
                        street: undefined,
                        town: undefined,
                        district: undefined,
                    }
                }
            });
            _this.props.removeErrors(_this.getFieldSet());
        };
        _this.focusElement = function (querySelector) {
            if (_this.onRef && _this.onRef.current) {
                setTimeout(function () {
                    var element = _this.onRef.current.querySelector(querySelector);
                    window.scrollTo(0, element.getBoundingClientRect().top + window.scrollY - 200);
                    element.focus();
                }, 100);
            }
        };
        _this.state = {
            stage: 'finder',
        };
        _this.onRef = React.createRef();
        if (_this.hasPopulatedData()) {
            if (_this.validateAll(false)) {
                _this.state = {
                    stage: 'selected',
                };
            }
            else {
                _this.state = {
                    stage: 'manual',
                };
            }
        }
        return _this;
    }
    AddressInput.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevState.stage !== this.state.stage) {
            if (this.state.stage === 'finder') {
                this.focusElement(getEscapedQuerySelector("#" + this.props.name + ".finder"));
            }
            if (this.state.stage === 'manual') {
                this.focusElement(getEscapedQuerySelector("#" + this.props.name + ".house_name"));
            }
        }
    };
    AddressInput.prototype.render = function () {
        var className = this.props.className;
        var wrapperClass = 'address-input';
        if (className) {
            wrapperClass += " " + className;
        }
        return (React.createElement("div", { className: wrapperClass, ref: this.onRef },
            (this.state.stage === 'finder' || this.props.disabled) ? this.addressFinder() : null,
            (this.state.stage === 'selected' && !this.props.disabled) ? this.addressSummary() : null,
            (this.state.stage === 'manual' && !this.props.disabled) ? this.addressManualInput() : null));
    };
    return AddressInput;
}(React.Component));
exports.default = AddressInput;
